export default "__VITE_ASSET__8d6beec7__"